import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Disable PWA: do not register service worker and attempt to unregister any existing ones.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      if (regs && regs.length > 0) {
        for (const r of regs) {
          try { await r.unregister(); } catch (e) {}
        }
        try { console.log('[SW] unregistered existing service workers'); } catch (_) {}
      }
    } catch (e) {
      try { console.warn('[SW] failed to unregister service workers:', e); } catch (_) {}
    }
  });
}
